export default "__VITE_ASSET__rW7Sm1Gw__"